export const appName = 'R3PLAYX'

// 动画曲线
export const ease: [number, number, number, number] = [0.4, 0, 0.2, 1]

// 屏幕断点
export const breakpoint = {
  xs: '@media (min-width: 240px)',
  sm: '@media (min-width: 640px)',
  md: '@media (min-width: 768px)',
  lg: '@media (min-width: 1024px)',
  xl: '@media (min-width: 1280px)',
  '2xl': '@media (min-width: 1536px)',
}

export const titleBarHeight = 32 // 桌面端标题栏高度 (px)
export const topbarHeight = 132 // 桌面端顶栏高度 (px)
export const playerWidth = 318 // 桌面端播放器宽度 (px)
